import React from 'react';
import { FormattedMessage } from 'react-intl';
import Select from '@atlaskit/select';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Box } from '@atlaskit/primitives';
import type { UserAction } from '../../../actions/login-actions';

export type CheckUsernameActionOption = { label: React.ReactNode; userAction: UserAction };

export type CheckUsernameActionSelectorProps = {
  options: CheckUsernameActionOption[];
  selectedOption: UserAction | null;
  onSelectActionChange: (value: UserAction) => void;
  fieldError?: string;
  isRequired?: boolean;
  isInvalid?: boolean;
};

const CheckUsernameActionSelector = ({
  options,
  selectedOption,
  onSelectActionChange,
  fieldError,
  isRequired,
  isInvalid,
}: CheckUsernameActionSelectorProps) => (
  <Box paddingBlockStart="space.100">
    <Label
      htmlFor="check-username-action-selector"
      aria-required={isRequired}
      id="check-username-action-selector-label">
      <FormattedMessage
        id="check-username-action-selector-label"
        defaultMessage="Environment"
        description="Label for the check username action selector"
      />
      <RequiredAsterisk />
    </Label>
    <Select<CheckUsernameActionOption, false>
      placeholder={
        <FormattedMessage
          id="check-username-action-selector-placeholder"
          defaultMessage="Select environment"
          description="Placeholder for the check username action selector"
        />
      }
      isRequired={isRequired}
      options={options}
      isClearable={false}
      // Labels are React nodes, so Atlaskit Select's default string filtering is not useful here.
      isSearchable={false}
      inputId="check-username-action-selector"
      testId="check-username-action-selector-idf-testid"
      onChange={selected => selected && onSelectActionChange(selected.userAction)}
      value={options.find(option => option.userAction === selectedOption)}
      isOptionSelected={option => option.userAction === selectedOption}
      isInvalid={isInvalid}
    />
    {isInvalid && fieldError && (
      <Box paddingBlockStart="space.050" testId="check-username-action-selector-error-idf-testid">
        {fieldError}
      </Box>
    )}
  </Box>
);

export default CheckUsernameActionSelector;
